import { StatesModule } from '@uirouter/angular';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { SiteMapListComponent } from '@fi-app/site-map/site-map-list/site-map-list.component';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { SiteMapViewComponent } from '@fi-app/site-map/site-map-view/site-map-view.component';
import { SiteMapEditComponent } from '@fi-app/site-map/site-map-edit/site-map-edit.component';
import { SiteMapService } from '@fi-app/site-map/site-map.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { TagService } from '@fi-app/tag/tag.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ISiteMap } from '@fi-shared/models/site-map';
import { SiteMapHelperService } from '@fi-shared/fi-shared-services/site-map-helper.service';

const SiteMapState = {
    name: FiStateNames.SiteMap._name,
    url: '/SiteMap',
    abstract: true,
    parent: FiStateNames.GlobalSettings,
    component: FiAbstractStateComponent,
};

export function SiteMapListPageTitle(ccmPageTitle: PageTitleService) {
    ccmPageTitle.setTitleByItem(ObjectTypes.SiteMap);
}
const SiteMapListState = {
    name: FiStateNames.SiteMap.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    reloadOnSearch: false,
    component: SiteMapListComponent,
    resolve: {
        pageTitle: [PageTitleService, SiteMapListPageTitle],
    },
};

export function SiteMapViewSiteMap(fiSiteMapService: SiteMapService, stateService: FiStateService, transition) {
    return fiSiteMapService.getSiteMap(stateService.getParams(transition).Id);
}
export function SiteMapViewPageTitle(ccmPageTitle: PageTitleService, siteMap: ISiteMap) {
    ccmPageTitle.setTitleByItem(siteMap);
}
const SiteMapViewState = {
    name: FiStateNames.SiteMap.View,
    url: '/{Id:[0-9]+}',
    views: {
        '@': {
            component: SiteMapViewComponent,
        },
    },
    resolve: {
        siteMap: [SiteMapService, FiStateService, '$transition$', SiteMapViewSiteMap],
        pageTitle: [PageTitleService, 'siteMap', SiteMapViewPageTitle],
    },
};

export function SiteMapCreateAllTags(tagService: TagService) {
    return tagService.getAllLightWeightTags();
}
export function SiteMapCreatePageTitle(ccmPageTitle: PageTitleService, siteMap: ISiteMap) {
    ccmPageTitle.setTitleByItem(siteMap);
}
const SiteMapCreateState = {
    name: FiStateNames.SiteMap.Add,
    url: '/Add',
    views: {
        '@': {
            component: SiteMapEditComponent,
        },
    },
    resolve: {
        siteMap: [
            SiteMapHelperService,
            (siteMapHelperServise: SiteMapHelperService) => siteMapHelperServise.getSiteMapInstance(),
        ],
        allTags: [TagService, SiteMapCreateAllTags],
        pageTitle: [PageTitleService, 'siteMap', SiteMapCreatePageTitle],
    },
};

export function SiteMapEditSiteMap(fiSiteMapService: SiteMapService, stateService: FiStateService, transition) {
    return fiSiteMapService.getSiteMapForEdit(stateService.getParams(transition).Id);
}
export function SiteMapEditAllTags(tagService: TagService) {
    return tagService.getAllLightWeightTags();
}
export function SiteMapEditPageTitle(ccmPageTitle, siteMap: ISiteMap) {
    ccmPageTitle.setTitleByItem(siteMap);
}
const SiteMapEditState = {
    name: FiStateNames.SiteMap.Edit,
    url: '/{Id:[0-9]+}/Edit',
    views: {
        '@': {
            component: SiteMapEditComponent,
        },
    },
    resolve: {
        siteMap: [SiteMapService, FiStateService, '$transition$', SiteMapEditSiteMap],
        allTags: [TagService, SiteMapEditAllTags],
        pageTitle: [PageTitleService, 'siteMap', SiteMapEditPageTitle],
    },
};

export const SiteMapStates: StatesModule = {
    states: [SiteMapState, SiteMapListState, SiteMapViewState, SiteMapCreateState, SiteMapEditState],
};

export function registerSiteMapStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.SiteMap.Edit, FiStateNames.SiteMap.Add], {
        SettingType: [ApplicationSettingsType.Tag],
        AccessType: AccessRightType.Admin,
    });

    stateAccessCheckService.registerStateRules([FiStateNames.SiteMap.List], {
        SettingType: [ApplicationSettingsType.Tag],
        AccessType: AccessRightType.Read,
    });
}
